import React, {Fragment, Component} from "react";
import {Link} from 'react-router-dom';

import PostsSlider from '../News';

import {Col, Row, Form, FormGroup, Label, Input} from 'reactstrap';
import LaddaButton, {
    ZOOM_IN
} from 'react-ladda';
import axios from 'axios';
import {toast} from 'react-toastify';
import {server_host_api, getLanguageApi} from '../../../Utils';

import PropTypes from 'prop-types';
import {translate} from 'react-switch-lang';



class Recovery extends Component {
    state = {
        password1: null,
        password2: null,
        uidb36: null,
        key: null,
        accessLoading: false,
        progress: 0,
    };
    
    constructor(props) {
        super(props);

        this.Change = this.Change.bind(this);
    }

    Change(event) {
        event.preventDefault();

        const { t } = this.props;

        if (!this.state.password1) {
            toast.warn(<div><b>{t('required_data')}</b><br /> {t('recovery.password_required')}</div>);
            return false;
        }

        if (!this.state.password2) {
            toast.warn(<div><b>{t('required_data')}</b><br /> {t('recovery.confirm_password_required')}</div>);
            return false;
        }

        if (this.state.password1 !== this.state.password2) {
            toast.warn(<div><b>{t('recovery.warning_toast_header')}</b><br /> {t('recovery.password_equal')}</div>);
            return false;
        }

        this.setState({
            accessLoading: true,
            progress: 0.5,
        });
    
        axios.post(`${server_host_api}/accounts/set_password/`,{
            "uidb36": this.state.uidb36,
            "key": this.state.key,
            "password1": this.state.password1,
            "password2": this.state.password2,
        },{
            headers: { "Accept-Language": getLanguageApi() }
        })
        .then(res => {
            if (res.status === 200) {
                this.setState({
                    accessLoading: false,
                    progress: 0,
                });

                toast.success(<div><b>{t('congrats')}</b><br /> {t('recovery.recovery_success_msg')}</div>);
            } else {
                if (res.response.data.data.message) {
                    res.response.data.data.message.forEach(e => {
                        toast.error(<div><b>{t('recovery.recovery_error')}</b><br /> {e}</div>);
                    });
                } else {
                    toast.error(<div><b>{t('recovery.recovery_error')}</b><br /> {t('recovery.recovery_error_msg')}</div>);
                }

                this.setState({
                    accessLoading: false,
                    progress: 0,
                });
            }
        })
        .catch(error => {
            this.setState({
                accessLoading: false,
                progress: 0,
            });

            if (error.response.data != null) {
                // if(error.response.data.data.message) {
                //     toast.error(<div><b>{t('recovery.recovery_error')}</b><br /> 
                //     {error.response.data.data.message.map((item, i) => {
                //         return (
                //           <p key={i} style={{ margin: 0, padding: 0 }}>
                //             {item}
                //           </p>
                //         );
                //       })}</div>);
                // }

                if (error.response.data.data.old_password != null) {
                    toast.error(<div><b>{t('recovery.recovery_error')}</b><br /> 
                    {error.response.data.data.old_password.map((item, i) => {
                        return (
                          <p key={i} style={{ margin: 0, padding: 0 }}>
                            {item}
                          </p>
                        );
                      })}</div>);
                }

                if (error.response.data.data.new_password2 != null) {
                    toast.error(<div><b>{t('recovery.recovery_error')}</b><br /> 
                    {error.response.data.data.new_password2.map((item, i) => {
                        return (
                          <p key={i} style={{ margin: 0, padding: 0 }}>
                            {item}
                          </p>
                        );
                      })}</div>);
                }
            } else {
                toast.error(<div><b>{t('recovery.recovery_error')}</b><br /> {t('recovery.recovery_error_error')}</div>);
            }
        });
        
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    
    componentDidMount () {
        let query = new URLSearchParams(this.props.location.search);

        let pUidb36 = query.get('uidb36');
        let pKey = query.get('key');

        this.setState({
            uidb36: pUidb36,
            key: pKey
        });
    }

    render() {
        const { t } = this.props;

        return (

            <Fragment>
                <div className="h-100">
                    <Row className="h-100 no-gutters">
                        <Col lg="4" md="12" className="h-100 d-flex bg-white justify-content-center align-items-center">
                            <Col lg="10" md="10" sm="12" className="mx-auto app-login-box">
                                <div className="app-logo"/>
                                <h4>
                                    <div>{t('recovery.recovery')}</div>
                                    <span>{t('recovery.recovery_msg')}</span>
                                </h4>
                                <div>
                                    <Form>
                                        <Row form>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Label for="password1">{t('recovery.password')}</Label>
                                                    <Input type="password" name="password1" id="password1" onChange={e => this.handleChange(e)}/>
                                                </FormGroup>
                                            </Col>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Label for="password2">{t('recovery.confirm_password')}</Label>
                                                    <Input type="password" name="password2" id="password2" onChange={e => this.handleChange(e)}/>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <div className="mt-4 d-flex align-items-center">
                                            <h6 className="mb-0">
                                                <Link to="/auth/login" className="text-primary">{t('recovery.access_exist')}</Link>
                                            </h6>
                                            <div className="ml-auto">
                                                <LaddaButton className="mb-2 mr-2 btn btn-primary" onClick={this.Change} loading={this.state.accessLoading} data-style={ZOOM_IN}>{t('recovery.change_password')}</LaddaButton>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </Col>
                        </Col>
                        <Col lg="8" className="d-none d-lg-block bg-secondary">
                            <div className="slider-light">
                                <PostsSlider/>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Fragment>
        );
    }
}

Recovery.propTypes = {
    t: PropTypes.func.isRequired,
};

export default translate(Recovery);